export default "__VITE_ASSET__CMj_codN__"